import { ref } from 'vue'
import { getLeaseSignProcessStatus, queryWalletSignFlowState,
  queryAlipaySignStatus } from '@/api/domain/orders'
import { miniStore } from '@/miniStore'

// 刷新签署状态
export function useRefreshSignStatus(id) {
  const loading = ref(false)

  const refreshInContactFlow = async (cb) => {
    const orderId = miniStore.state.data.global.orderId || id
    loading.value = true
    const { code, data } = await getLeaseSignProcessStatus({
      orderId,
    })
    loading.value = false
    if (code === 1) {
      cb?.(data)
      miniStore.dispatch({
        type: 'BATCH_UPDATE_FIELD',
        payload: {
          updates: {
            step1: {
              flowState: data.flowState,
            },
          },
        },
      })
    }
  }

  // 刷新网约钱包状态(详情页)
  const refreshWalletSignStatus = async (orderId, cb) => {
    loading.value = true
    try {
      const { code, data } = await queryWalletSignFlowState({
        orderId,
      })
      if (code === 1) {
        cb?.(data)
      }
    } catch (error) {
      console.error(error)
    } finally {
      loading.value = false
    }
  }

  // 刷新支付宝状态(详情页)
  const refreshAlipaySignStatus = async (orderId, cb) => {
    loading.value = true
    try {
      const { code, data } = await queryAlipaySignStatus({
        orderId,
      })
      if (code === 1) {
        cb?.(data)
      }
    } finally {
      loading.value = false
    }
  }

  return {
    loading,
    refreshInContactFlow,
    refreshWalletSignStatus,
    refreshAlipaySignStatus,
  }
}
